import React, { useEffect, useState } from "react";
import Headar from "../Component/Headar";
import Footer from "../Component/Footer";
import ShapeImg from "../aseets/img/membership_curve.png";
import BradCrum from "../Component/BradCrum";
import PlatinumFamily from "../Component/PlatinumFamily";
import TestimonialBaner from "../aseets/img/testimonial.png";
import Quest from "../aseets/img/straight-quotes 1 (Traced).png";
import { Card, Col, Container, Row } from "react-bootstrap";
import MobileHader from "../Component/MobileHader";
import axios from "axios";
import { InfinitySpin } from "react-loader-spinner";

const Testimonial = () => {
  const [testimonialData, setTestimonialData] = useState([]);
  const getTestimonialData = async () => {
    try {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/api/auth/listActive/Testimonials`
        )
        .then((res) => {
          setTestimonialData(res.data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getTestimonialData();
  }, []);
  const [bannerImages, setBannerImages] = useState({});
  useEffect(() => {
    const fetchBannerImages = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/auth/list/inner-banners`
        );
        if (
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 2
        ) {
          setBannerImages(response.data, "===>");
        }
      } catch (error) {
        console.error("Error fetching banner images:", error);
      }
    };

    fetchBannerImages();
  }, []);

  // const testimonialData = [
  //   {
  //     discription:"Platinum Matches exceeded my expectations. Their personalized matchmaking and coaching truly helped me find someone I deeply connect with",
  //     title:"-Aarav, 32, Corporate Lawyer",
  //     subTitle:'USA'
  //   },
  //   {
  //     discription:"I never thought finding someone so compatible would be this smooth. Platinum Matches’ blend of tradition and innovation truly works wonders.",
  //     title:"-Rahul, 30, Software Engineer",
  //     subTitle:'Canada'
  //   },
  //   {
  //     discription:"Their expertise in understanding my needs was incredible. I found my partner within months, and we’re so happy together!",
  //     title:"-Diya, 28, Marketing Manager",
  //     subTitle:'UAE'
  //   },
  //   {
  //     discription:"The personalized coaching sessions helped me understand what I was truly looking for in a partner. Forever grateful to Platinum Matches!",
  //     title:"-Neha, 32, Financial Analyst",
  //     subTitle:'India'
  //   },
  //   {
  //     discription:"Platinum Matches changed my perspective on matchmaking. Their personalized service helped me meet someone who’s now the love of my life. Highly recommend it!",
  //     title:"-Meera, 27,Entrepreneur",
  //     subTitle:' UK'
  //   },
  //   {
  //     discription:"Platinum Matches stands out in every way possible. They’re not just about connecting people; they’re about building meaningful relationships. The team’s effort to find the right partner for me was evident from day one. I’m grateful for their commitment and expertise in helping me find someone who aligns perfectly with my values and goals.",
  //     title:"-Kunal, 39, Architect",
  //     subTitle:' UAE'
  //   },
  //   {
  //     discription:"Quick, efficient, and life-changing. Highly recommend their service!",
  //     title:"-Arjun, 27,Pilot",
  //     subTitle:' USA'
  //   },
  //   {
  //     discription:"I found the entire process professional yet personal. The team really cared, and it showed. I’m now happily married to the one!",
  //     title:"-Avni, 29, HR Specialist",
  //     subTitle:'India'
  //   },
  //   {
  //     discription:"I found the entire process professional yet personal. The team really cared, and it showed. I’m now happily married to the one!",
  //     title:"-Avni, 29, HR Specialist",
  //     subTitle:'India'
  //   },
  // ]
     const [isLoading, setIsLoading] = useState(true);
      useEffect(() => {
        // Simulate a delay of 2 seconds (adjust as needed)
        const delay = 1000;
        setTimeout(() => {
          setIsLoading(false);
        }, delay);
      }, []);
  return (
    <React.Fragment>
         {isLoading ? (
                      // Loader component while loading
                      <div className="loader-container">
                        <InfinitySpin
                          color="#000"
                          height={50}
                          width="200"
                          timeout={0} // 0 means no timeout, loader will be displayed until setIsLoading(false) is called
                        />
                      </div>
                    ) : (
      <div>
      <Headar />
      <MobileHader />
      <BradCrum
        Title={bannerImages[2]?.Title}
        ShapeImg={ShapeImg}
        BradCrumImg={`${process.env.REACT_APP_API_URL}/${bannerImages[2]?.bannerImage}`}
        color="#fff"
      />
      <div className="testiMonialBackgroundSection">
        <Container>
          <Row>
            <Col lg={6} md={6}>
              <div className="testiMonialTitle">
              Rohan Gupta, 30, Entrepreneur  
              </div>
              <div className="contryTitle">USA</div>
            </Col>
            <Col lg={6} md={6}>
              <div>
                <div>
                  <img className="quetIcon" src={Quest} alt="icon" />
                </div>
                <div className="testimonsialDescription">
                  "I never imagined I’d meet someone who feels like a perfect
                  reflection of my soul. She’s not just beautiful — her
                  kindness, wisdom, and unwavering support make every moment
                  feel extraordinary. With her, I’ve found peace, joy, and a
                  future I’m excited about. Platinum Matches didn’t just
                  introduce me to a partner; they brought me my forever. I’ll
                  always be grateful for their expertise and genuine care."
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* //// ===> testimonial list */}
      <Container className="testimonialContainer">
        <Row>
          {testimonialData?.map((data) => (
            <Col className="testimonialcol" lg={4} md={6}>
              <Card className="storyCard testiMonialCard">
                <div className="suceessDescriptionDiv">{data.description}</div>
                <div className="authTitle">
                  -{data.clientName}, {data.age}, {data.profession}.
                </div>
                <div className="authSubTitle">{data.country}</div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <PlatinumFamily />
      <Footer />
      </div>
          )}
    </React.Fragment>
  );
};

export default Testimonial;
